const SearchLg = ({ size = 24 }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24">
      <path
        d="M11.5 4a7.5 7.5 0 1 0 5.188 12.916 1.01 1.01 0 0 1 .228-.228A7.5 7.5 0 0 0 11.5 4Zm7.388 13.473A9.461 9.461 0 0 0 21 11.5a9.5 9.5 0 1 0-9.5 9.5 9.46 9.46 0 0 0 5.973-2.113l2.82 2.82a1 1 0 0 0 1.414-1.414l-2.82-2.82Z"
        fillRule="evenodd"
        fill="currentColor"
      />
    </svg>
  );
};

export default SearchLg;
